module.exports = __webpack_public_path__ + "media/images/countrysquared/np-6da5024e1b2f049303fdaf7d4affe801.svg";